import { Box, styled } from '@mui/material';

export const LoaderW = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
`;
